import { Input, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { css } from '@emotion/react';
import { gql } from '@apollo/client';
import {
  useCreateBusinessContentBulkMutation,
  useGetAllBusinessContentQuery,
} from 'generated/graphql';
import { useNavigate } from 'react-router-v7';
import Button from 'ui/Button';
import ClowncarBodyV2 from 'components/ClowncarBodyV2';
import ClowncarHeaderV2 from 'components/ClowncarHeaderV2';
import Papa from 'papaparse';
import React from 'react';
import type { BusinessContentFormValues } from './BusinessContentFormRoute';

export const ALL_BUSINESS_CONTENT = gql`
  query GetAllBusinessContent {
    allBusinessContent {
      businessId
      venueId
      needToKnow
      whyWeLikeIt
    }
  }
`;

gql`
  mutation CreateBusinessContentBulk($businessContents: [UpdateBusinessContentInput!]!) {
    createBusinessContentBulk(businessContents: $businessContents) {
      businessId
      venueId
      needToKnow
      whyWeLikeIt
    }
  }
`;

const inputStyles = css`
  display: flex;
  gap: 8px;
  align-items: center;
`;

const BusinessContentRoute: React.FC = () => {
  const navigate = useNavigate();
  const { data, loading } = useGetAllBusinessContentQuery();
  const [createBusinessContentBulk] = useCreateBusinessContentBulkMutation();

  const handleCreate = () => {
    navigate('/jce-business-content/create');
  };

  const handleUpload = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      Papa.parse(file, {
        header: true,
        skipEmptyLines: true,
        delimiter: ',',
        complete: async (results: { data: BusinessContentFormValues[] }) => {
          const parsedData = results.data.map((row: BusinessContentFormValues) => ({
            venueId: row.venueId ? Number(row.venueId) : null,
            businessId: row.businessId ? Number(row.businessId) : null,
            needToKnow: row.needToKnow,
            whyWeLikeIt: row.whyWeLikeIt,
          }));

          await createBusinessContentBulk({
            variables: { businessContents: parsedData },
            refetchQueries: [{ query: ALL_BUSINESS_CONTENT }],
          });
        },
      });
    }
  };

  return (
    <div className="Content">
      <ClowncarHeaderV2
        heading="Business Content"
        actions={
          <div css={inputStyles}>
            <Button color="primary" onClick={handleCreate} variant="contained">
              New
            </Button>
            <Input type="file" onChange={handleUpload} />
          </div>
        }
      />
      <ClowncarBodyV2 isLoading={loading}>
        <TableContainer>
          <TableHead>
            <TableRow>
              <TableCell>Venue Id</TableCell>
              <TableCell>Business Id</TableCell>
              <TableCell>Need To Know</TableCell>
              <TableCell>Why We Like It</TableCell>
              <TableCell />
            </TableRow>
          </TableHead>
          <TableBody>
            {data?.allBusinessContent?.map((content, idx) => (
              <TableRow key={idx}>
                <TableCell>{content.venueId}</TableCell>
                <TableCell>{content.businessId}</TableCell>
                <TableCell>{content.needToKnow}</TableCell>
                <TableCell>{content.whyWeLikeIt}</TableCell>
                <TableCell>
                  <Button
                    color="primary"
                    onClick={() =>
                      navigate(
                        `/jce-business-content/${content.businessId ? 'tock' : 'resy'}/${content.businessId || content.venueId}/edit`
                      )
                    }
                    variant="contained"
                  >
                    Edit
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </TableContainer>
      </ClowncarBodyV2>
    </div>
  );
};

export default BusinessContentRoute;
